import {appInsights} from '@/shared/services/appInsights';

type LogProperties = Record<string, unknown>;

const toError = (message: string, error?: unknown): Error => {
    if (error instanceof Error) return error;
    if (typeof error === 'string') return new Error(error);
    return new Error(message);
};

export const logInfo = (message: string, properties?: LogProperties) => {
    appInsights.trackEvent({name: 'client_info', properties: {message, ...(properties ?? {})}});
};

export const logWarn = (message: string, properties?: LogProperties) => {
    appInsights.trackEvent({name: 'client_warn', properties: {message, ...(properties ?? {})}});
};

export const logError = (message: string, error?: unknown, properties?: LogProperties) => {
    appInsights.trackException({
        exception: toError(message, error),
        properties: {message, ...(properties ?? {})},
    });
};
